import { AlertTriangle, Inbox, LoaderCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/Button";

interface PageStateProps {
  kind: "loading" | "empty" | "error";
  title?: string;
  description?: string;
  onRetry?: () => void;
}

export function PageState({
  kind,
  title,
  description,
  onRetry,
}: PageStateProps) {
  const { t } = useTranslation();
  const Icon =
    kind === "loading" ? LoaderCircle : kind === "error" ? AlertTriangle : Inbox;

  return (
    <div
      className="flex min-h-56 flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border bg-muted/20 p-8 text-center"
      role={kind === "error" ? "alert" : "status"}
    >
      <Icon
        className={kind === "loading" ? "size-6 animate-spin text-accent" : "size-6 text-muted-foreground"}
        aria-hidden="true"
      />
      <div>
        <div className="text-sm font-medium">
          {title ?? t(`states.${kind}.title`)}
        </div>
        {(description || kind !== "loading") && (
          <p className="mt-1 max-w-lg text-xs leading-5 text-muted-foreground">
            {description ?? t(`states.${kind}.description`)}
          </p>
        )}
      </div>
      {kind === "error" && onRetry && (
        <Button type="button" size="sm" variant="outline" onClick={onRetry}>
          {t("actions.retry")}
        </Button>
      )}
    </div>
  );
}

